export enum MsalFlow {
  Invite = 'invite',
  NonSigningAgentLogin = 'nonsa-login',
  NonSigningAgentAccountLogin = 'nonsa-account-login',
  PinLogin = 'pinlogin',
  SigningAgentLogin = 'sa-login',
}
